import { render, staticRenderFns } from "./OrganizationReviewStatus.vue?vue&type=template&id=f995ddb2&"
import script from "./OrganizationReviewStatus.vue?vue&type=script&lang=ts&"
export * from "./OrganizationReviewStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports